import { Box } from "@mui/material";

import { theme } from "~/config/theme";

import IconArea from "../IconArea";
import { ChangeCircleOutlined } from "@mui/icons-material";

type GaiaMapMarkerAreaProps = {
    plannerStatusBucket: string;
    hasStagedChanges?: boolean;
    selected?: boolean;
};

export function GaiaMapMarkerArea({ plannerStatusBucket, hasStagedChanges, selected }: GaiaMapMarkerAreaProps) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: selected ? 64 : 56,
                height: selected ? 64 : 56,
                boxSizing: "border-box",
                border: `4px solid ${selected ? theme.palette.primary.main : "white"}`,
                borderRadius: "100%",
                backgroundColor: "white",
                cursor: "pointer",
                transition: theme.transitions.create(["opacity"], {
                    duration: theme.transitions.duration.short,
                }),
                opacity: 1,
                "@starting-style": {
                    opacity: selected ? 1 : 0,
                },
            }}
        >
            
            <IconArea plannerStatusBucket={plannerStatusBucket}>
                {hasStagedChanges && <ChangeCircleOutlined color="warning" fontSize="medium" />}
            </IconArea>
        </Box>
    );
}
